import { render, staticRenderFns } from "./CustomerCorporateInvoiceForm.vue?vue&type=template&id=65b3463e&scoped=true"
import script from "./CustomerCorporateInvoiceForm.vue?vue&type=script&lang=js"
export * from "./CustomerCorporateInvoiceForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerCorporateInvoiceForm.vue?vue&type=style&index=0&id=65b3463e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b3463e",
  null
  
)

export default component.exports